import React from 'react'
import { number, bool, string, object } from 'prop-types'
import { css } from '@emotion/react'

import useHydrationContext from '@/hooks/useHydrationContext'
import { roundUpWithDecimal } from '@/utils/func'

import RateTooltip from './Tooltip'
import Stars from './Stars'

const ratingWrapperCss = ({ font }) => css`
  display: flex;
  align-items: center;
  font-weight: ${font.bold};
  font-size: 10px;
`

const Rating = ({
  id,
  rate,
  votes,
  size = 12,
  canVote = false,
  hideSummary = false,
  className,
  showVotes,
  starsCount,
  developer,
}) => {
  const hydrated = useHydrationContext()

  if (!hydrated) {
    return null
  }

  const decimalRate = roundUpWithDecimal(rate)

  return (
    <div css={ratingWrapperCss} className={className}>
      <Stars
        rate={decimalRate}
        starsCount={starsCount}
        votes={votes}
        size={size}
        canVote={canVote}
        hideSummary={hideSummary}
        showVotes={showVotes}
      />
      {canVote && <RateTooltip id={id} votes={votes} developer={developer} />}
    </div>
  )
}

Rating.propTypes = {
  id: string,
  rate: number,
  votes: number,
  size: number,
  canVote: bool,
  hideSummary: bool,
  className: string,
  starsCount: number,
  showVotes: bool,
  developer: object,
}

export default Rating
